import styled from 'styled-components';

export const FilterStyled = styled.div`
  display: flex;
  align-items: center;
`;

export const TextWrapper = styled.span`
  margin-right: 0.5rem;
`;
